module.exports = __webpack_public_path__ + "img/background-panel-hello.1c063c9c.svg";